import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApiRequestBody, OpalApiRequestParams } from '../../schema'

type CreateStageParams = OpalApiRequestParams<'CreateStageV2'>
type CreateStageRequestBody = OpalApiRequestBody<'CreateStageV2'>

export const createStage = async ({
  params,
  requestBody,
}: {
  params: CreateStageParams
  requestBody: CreateStageRequestBody
}) => {
  const url = new URL('/workflows/v2/stages', window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
